import {
  FETCH_PRODUCT_REQUEST,
  FETCH_PRODUCT_SUCCESS,
  FETCH_PRODUCT_FAILURE,
} from "./productTypes";
import api from "../../utils/Api";

export const fetchproductRequest = () => {
  return {
    type: FETCH_PRODUCT_REQUEST,
  };
};

export const fetchproductSuccess = (product) => {
  return {
    type: FETCH_PRODUCT_SUCCESS,
    payload: product,
  };
};

export const fetchproductFailure = (error) => {
  return {
    type: FETCH_PRODUCT_FAILURE,
    payload: error,
  };
};

export const fetchproduct = (product_name) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchproductRequest());
    try {
      const response = await api.get(
        "inventory/product/autocomplete?product_name=" + product_name,
        {
          headers: headers,
        }
      );

      const product = response.data.data;
      //console.log("******* product autocomplete - ", product);
      dispatch(fetchproductSuccess(product));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchproductFailure(errorMsg));
    }
  };
};
